module.exports = "<article> <vision-text-section ng-repeat=\"content in ::item.contents track by $index\" data=content find=find level=1></vision-text-section> </article> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/visionText/js/visionText/visionText.html
// module id = 1092
// module chunks = 0